import FeedbackWrittenTestimonialModule from './FeedbackWrittenTestimonialModule'

export default FeedbackWrittenTestimonialModule
